const lbaHotel = angular.module('app.lbaHotel', [
  require('../lbaDupeHotel/lbaDupeHotel').name
]);

lbaHotel.controller('lbaHotelCtrl', require('./lbaHotelCtrl'));
lbaHotel.directive('lbaHotel', require('./lbaHotelDir'));
lbaHotel.service('hotelsService', require('../../services/hotelsService'));

export default lbaHotel;



// WEBPACK FOOTER //
// ./src/components/lbaHotel/index.js